export default "__VITE_ASSET__BnoBtocN__"